import React from 'react';
import PropTypes from "prop-types";
import LoadingOverlay from 'react-loading-overlay';
import theme from '../../Theme/theme';

const LoadingSpinner = props => (
    <LoadingOverlay
        active={props.loading}
        spinner
        text={props.message ? props.message : 'Loading...'}
        styles={{
            overlay: (base) => ({
                ...base,
                flex: 1,
                color: theme.color.white,
                background: theme.color.shadowColor
            }),
            spinner: (base) => ({
                ...base,
                width: 50,
                '& svg circle': {
                    stroke: theme.color.white
                }
            }),
            wrapper: (base) => ({
                ...base,
                position: "none",
                width: "100%",
                height: "100%"
            })
        }}
    />
);

LoadingSpinner.propTypes = {
    loading: PropTypes.bool.isRequired,
    message: PropTypes.string
};

export default LoadingSpinner;

